<template>
    <div class="property" v-if="(properties.values && properties.values.length) || (properties.values_text && properties.values_text.length)">
        <p class="title">{{ properties.name }}</p>

        <div class="checkbox alt js-property"
             v-for="(property, key) in handleLoopItems(properties, 0, 10)"
             :key="key"
        >
            <label>
                <template v-if="properties.input === 'select'">
                    <input type="checkbox"
                           :name="`properties[${property.property_id}][]`"
                           :value="property.id"
                           @change="handleChange"
                    >
                </template>
                <template v-else>
                    <input type="checkbox"
                           :name="`properties[${property.property_id}][]`"
                           :value="property.value"
                           @change="handleChange"
                    >
                </template>
                <span class="check">
                    <img src="/img/icons/check-white.svg" v-svg-inline>
                </span>
                <span class="label">
                    {{ property.value }}
                </span>
            </label>
        </div>

        <span v-if="(properties.values && properties.values.length > 10) || (properties.values_text && properties.values_text.length > 10)"
              class="show-more"
              @click="showAll"
        >
            {{ showMoreText }}
        </span>

        <div class="checkbox alt js-property d-none"
             v-for="(property, key) in handleLoopItems(properties, 10)"
             :key="key"
        >
            <label>
                <template v-if="properties.input === 'select'">
                    <input type="checkbox"
                           :name="`properties[${property.property_id}][]`"
                           :value="property.id"
                           @change="handleChange"
                    >
                </template>
                <template v-else>
                    <input type="checkbox"
                           :name="`properties[${property.property_id}][]`"
                           :value="property.value"
                           @change="handleChange"
                    >
                </template>
                <span class="check">
                    <img src="/img/icons/check-white.svg" v-svg-inline>
                </span>
                <span class="label">
                    {{ property.value }}
                </span>
            </label>
        </div>

        <div class="divider" v-if="(index + 1) < length"></div>
    </div>
</template>

<script>
import { onMounted, inject } from 'vue'

export default {

    emits: ['on-property-changed'],

    props: [
        'properties',
        'index',
        'length',
        'showMoreText'
    ],

    setup(props, { emit }) {

        const constants = inject('constants')
        const emitter   = inject('emitter')

        onMounted( () => {
            // console.log(
            //     props.index,
            //     props.length,
            //     props.properties
            // )
            emitter.on('set-values-from-parameters', ({ properties }) => {
                if ( properties && properties.length  ) handleCheckedInputs(properties.split(','))
            })
        })

        function handleCheckedInputs(Ids) {
            Array.from(document.querySelectorAll('.js-property input:not(input[type="hidden"])')).forEach( (input) => {
                if ( Ids.includes(input.value) )
                    input.checked = true
            })
        }

        function handleChange() {
            if ( constants.clientWidth > 991 ) emit('on-property-changed')
        }

        function showAll(e) {
            e.target.style.display = 'none'
            document.querySelectorAll('.js-property.d-none').forEach( (item, index) => {
                item.classList.remove('d-none')
            })
        }

        function handleLoopItems(properties, sliceStart, sliceEnd) {
            if ( properties.values && properties.values.length )
                return properties.values.slice(sliceStart, sliceEnd)
            else if ( properties.values_text && properties.values_text.length )
                return properties.values_text.slice(sliceStart, sliceEnd)
        }

        return {
            handleChange,
            showAll,
            handleLoopItems,
        }
    }
}
</script>
